<div class="selector-container">
  <label class="form-label">
    {{ displayName }} {{ !withoutLocation ? ('ServicingService::Location' | abpLocalization) : '' }}
  </label>

  <div>
    <button
      *ngIf="!name"
      type="button"
      class="btn btn-outline-secondary"
      (click)="onSelectClicked()"
    >
      {{ 'AbpUi::Select' | abpLocalization }}
    </button>

    <div *ngIf="name">
      <span>{{ name }}</span>
      <i class="fas fa-times fa-lg ms-2" (click)="onRemove()"></i>
    </div>
  </div>
</div>

<abp-modal [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h5>{{ displayName }} {{ 'RegisterService::Locations' | abpLocalization }}</h5>
  </ng-template>
  <ng-template #abpBody>
    <app-locations-with-search
      [readonly]="readonly"
      (selectedNodeChange)="onSelectedNodeChange($event)"
      [locationDefinition]="locationDefinition"
      [withLookup]="withLookup"
      [selectedLocation]="selectedLocation"
      [hasAssociatedInspections]="hasAssociatedInspections"
      [hasAssociatedAssets]="hasAssociatedAssets"
      [displayHeaders]="false"
    ></app-locations-with-search>
  </ng-template>
  <ng-template #abpFooter>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onSelect()"
      [disabled]="!selectedLocationTemp"
    >
      {{ 'AbpUi::Apply' | abpLocalization }}
    </button>

    <button type="button" class="btn btn-secondary" (click)="onCancel()">
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
